import React from 'react';

function PrivacyPolicy() {
    return (
        <div>
            <h1>Privacy Policy</h1>
            <p>{"I don't collect or share any information, and I don't run any ads. This is a simple game I made to get better at coding."}</p>
            <p>{"There is currently no online interaction, and all aspects of the app are safe for children. Enjoy :)"}</p>
        </div>
    )
}

export default PrivacyPolicy
